import { Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AuthComponent, data: { module: 'LOGIN' } },
  { path: 'register', component: AuthComponent, data: { module: 'REGISTER' } },
  { path: 'recovery', component: AuthComponent, data: { module: 'RECOVERY_PASSWORD' } },
  { path: 'seleccionar-portal', redirectTo: 'login' },
  { path: '**', redirectTo: 'login' },
];
